import {FC, memo} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {IReview} from 'modules/product-card/models/Review';
import {Avatar} from 'components/Avatar';
import {getMediaSrc} from 'core/helpers/media';
import {UNKOWN_NAME} from 'modules/products/constants';
import {format, parse} from 'date-fns';
import {ru} from 'date-fns/locale';

interface IProps {
    comments: IReview[];
}

export const ProductReviewCommentsList: FC<IProps> = memo(({comments}) => {
    return (
        <div>
            {comments.map(({author, comment, id, createdAt}) => {
                // используем fullName из API, если он есть
                // для старых анонимных отзывов (когда нет fullName, но есть author) показываем "Винный аноним"
                const authorFullName = author?.fullName || (author ? UNKOWN_NAME : UNKOWN_NAME);
                const userInitials = author?.userInitials;

                return (
                    <div className={style.comment} key={id}>
                        <Typography className={style.text}>{comment}</Typography>
                        {Boolean(author) && (
                            <div className={style.commentUserInfo}>
                                <Avatar
                                    className={style.avatar}
                                    personalPhoto={getMediaSrc(author?.personalPhoto, {
                                        height: 100,
                                        width: 100,
                                        isWebp: true,
                                    })}
                                    userInitials={userInitials}
                                />
                                <Typography className={style.userName} color={'gray60'}>
                                    {authorFullName}
                                </Typography>
                                <Typography className={style.date} color={'gray60'} variant={'p'}>
                                    {format(parse(createdAt, 'yyyy-MM-dd HH:mm:ss', new Date()), 'dd.MM.yy', {
                                        locale: ru,
                                    })}
                                </Typography>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
});
